import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContainerRefDirective } from '@common/directives';
import { PopupItem } from 'src/app/common/services/popup/popup-item';
import { PopupService } from 'src/app/common/services/popup/popup.service';
import { ServiceStock } from 'src/app/service-stock.service';

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss']
})
export class InfoPopupComponent implements OnInit, AfterViewInit,OnDestroy {

  @ViewChild(ContainerRefDirective, {static: true}) containerRef!: ContainerRefDirective;
  popupItem:PopupItem;
  title:string = "";


  constructor(
    private dialogRef: MatDialogRef<InfoPopupComponent>, 
    @Inject(MAT_DIALOG_DATA) private data: any,
    private popupService:PopupService,
    public services: ServiceStock
  ) { }

  ngOnDestroy(): void {
    document?.body?.classList?.remove('info-popup');
  }

  ngOnInit(): void {
    let component = this.popupService.getPopup(this.data.component);
    this.title = this.data.screenTitle;

    this.popupItem = component;
  }

  ngAfterViewInit(){
    this.loadComponent();
  }

  loadComponent() {
    const popup = this.popupItem;

    const viewContainerRef = this.containerRef.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(popup.component);
    componentRef.instance.data = this.data;
    document.body.classList.add('info-popup');
  }

  closePopup(){
    this.dialogRef.close();
    document.body.classList.remove('info-popup');
  }

}
